/** Vrsta troška iz šifrarnika — sistemska (vidljiva svima) ili tenantova. */
export interface ExpenseType {
  id: string;
  name: string;
  code: string | null;
  parentId: string | null;
  /** "vehicle" | "company" | "both" — gdje se grupa nudi. */
  appliesTo: string | null;
  ordinal: number;
  parentName: string | null;
  /** „Uprava → Knjigovodstvo" — da se podgrupa prepozna i izvan stabla. */
  fullName: string;
  isSystem: boolean;
}

/** Na što se vrsta troška odnosi; mora odgovarati backendu. */
export const ExpenseAppliesTo = {
  VEHICLE: "vehicle",
  COMPANY: "company",
  BOTH: "both",
} as const;
